<template>
  <section
    class="workflow-steps-overlay"
    :style="rootStyle"
    aria-label="StoReel workflow steps"
  >
    <h2 class="workflow-steps-overlay__title" :style="boxStyle(intro.titleBox)">
      {{ intro.title }}
    </h2>
    <p class="workflow-steps-overlay__subtitle" :style="boxStyle(intro.subtitleBox)">
      {{ intro.subtitle }}
    </p>

    <div class="workflow-steps-overlay__cards" :style="sliceStyle(cardsSlice)" aria-hidden="true">
      <img
        class="workflow-steps-overlay__cards-image"
        :src="cardsSlice.src"
        :srcset="cardsSlice.srcset"
        sizes="100vw"
        width="1920"
        :height="cardsSlice.sourceH ?? cardsSlice.h"
        alt=""
        :loading="cardsSlice.loading"
        decoding="async"
        :fetchpriority="cardsSlice.fetchPriority"
        draggable="false"
        :style="sliceImageStyle(cardsSlice)"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { CSSProperties } from 'vue'

import type { DesignBox, FigmaSection, WorkflowIntro } from '../../data/home2026'

const props = defineProps<{
  intro: WorkflowIntro
  cardsSlice: FigmaSection
  scaledPx: (value: number) => string
}>()

const rootStyle = computed<CSSProperties>(() => ({
  '--workflow-title-font': props.scaledPx(50),
  '--workflow-title-line': props.scaledPx(70),
}) as CSSProperties)

const boxStyle = (box: DesignBox): CSSProperties => ({
  left: props.scaledPx(box.x),
  top: props.scaledPx(box.y),
  width: props.scaledPx(box.w),
  height: props.scaledPx(box.h),
})

const sliceStyle = (section: FigmaSection): CSSProperties => ({
  left: 0,
  top: props.scaledPx(section.y),
  width: '100%',
  height: props.scaledPx(section.h),
})

const sliceImageStyle = (section: FigmaSection): CSSProperties => ({
  height: props.scaledPx(section.sourceH ?? section.h),
  transform:
    section.cropTop !== undefined ? `translateY(-${props.scaledPx(section.cropTop)})` : undefined,
})
</script>

<style scoped>
.workflow-steps-overlay {
  position: absolute;
  z-index: 3;
  inset: 0;
  color: #fff;
  pointer-events: none;
  font-synthesis: none;
  -webkit-font-smoothing: antialiased;
  text-rendering: geometricprecision;
}

.workflow-steps-overlay__title,
.workflow-steps-overlay__subtitle {
  position: absolute;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  letter-spacing: 0;
  white-space: pre-line;
}

.workflow-steps-overlay__title {
  font-family: AlibabaPuHuiTi_3_85_Bold, 'Alibaba PuHuiTi 3.0', PingFangSC-Regular, Source Han Sans CN, sans-serif;
  font-size: var(--workflow-title-font);
  font-weight: 700;
  line-height: var(--workflow-title-line);
}

.workflow-steps-overlay__subtitle {
  font-family: AlibabaPuHuiTi_3_65_Medium, 'Alibaba PuHuiTi 3.0', PingFangSC-Regular, Source Han Sans CN, sans-serif;
  font-size: var(--workflow-title-font);
  font-weight: 500;
  line-height: var(--workflow-title-line);
}

.workflow-steps-overlay__cards {
  position: absolute;
  overflow: hidden;
}

.workflow-steps-overlay__cards-image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  object-fit: fill;
  user-select: none;
  pointer-events: none;
}
</style>
